import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css'; 

let problemScored=(props)=> { 
  
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  
  Problem ScoreCard
  </h4>
        <br></br>
        <h6 id="h62">
  Probem ScoreCard Informs your the strength of the problem you are trying to Solve?</h6>
        <h6 id="h6">
  it has direct relation with your ability to monitize your solution.</h6>
        <h6 id="h6">
  And What are your Coustomer's Cureent oprions to solve the problem , Reger to the Chart
  </h6>
        <h6 id="h6">
  The Overalll Problem score is seen with respect to kind of funding and other resources you have</h6>
        <div id='divL'>
          <div id='selectDiv'>
            <p id='selectp'>Buyer motivation parity Scroe</p>
            <input type='text' ></input>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Market Size</p>
            <select className="select1 m0" >
              <option value="0">few/ 000's / 000,000s:</option>
              <option value="1">Few Coustomer</option>
              <option value="2">000's Thousands</option>
              <option value="3">000,000's million</option>

            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Frequency of Problem</p>
            <select className="select1 m0" >
              <option value="0">low /medium /high:</option>
              <option value="1">low</option>
              <option value="2">medium</option>
              <option value="3">high</option>

            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Time Saving opportunity</p>
            <select className="select1 m0" >
              <option value="0">1x /10x 100x</option>
              <option value="1">1x</option>
              <option value="2">10x</option>
              <option value="3">100x</option>

            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Life of problem</p>
            <select className="select1 m0" >
              <option value="0">Months / Years:</option>
              <option value="1">Months</option>
              <option value="2">Years</option>
            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Life Saving</p>
            <select className="select1 m0" >
              <option value="0">No  / Yes:</option>
              <option value="1">No</option>
              <option value="2">Yes</option>
            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Convaniance / Comfort</p>
            <select className="select1 m0" >
              <option value="0">No / Yes:</option>
              <option value="1">no</option>
              <option value="2">yes</option>
            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>REgularity Requirment</p>
            <select className="select1 m0" >
            <option value="0">No / Yes:</option>
              <option value="1">no</option>
              <option value="2">yes</option>
            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Security</p>
            <select className="select1 m0" >
              <option value="0">Enh / Prev / Resp:</option>
              <option value="1">Enhance</option>
              <option value="2">Previous</option>
              <option value="2">Previous</option>

            </select>
          </div>
          <div id='selectDiv'>
            <p id='selectp'>Total</p>
            <input type='text' ></input>

          </div>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/buyerMotivation')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/problemValidation')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default problemScored;